import { canUseMedianNativeDownload, formatFilePath } from './url';

export const downloadURL = (url: string, filename: string) => {
  // Download file on native device (only for http(s); blob/data stay in WebView)
  if (window.median?.share?.downloadFile && canUseMedianNativeDownload(url)) {
    const parsedUrl = formatFilePath(url);
    window.median.share.downloadFile({
      url: parsedUrl,
      filename,
      open: true,
    });
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
